/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { AutoActionMailContentState } from '../state/AutoActionMailContentState'
import { AutoMailContentActionTypes } from '../../action/auto_action/AutoMailContentActions'

class AutoActionMailStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AutoActionMailContentState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AutoMailContentActionTypes.fetchOne:
        const content = payload.auto_action_mail_content
        return state.merge(content)

      case AutoMailContentActionTypes.onCancel:
        return state.clear()

      case AutoMailContentActionTypes.onEdit:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new AutoActionMailStore()
